import { Box } from '@mui/material';
import Snowfall from 'react-snowfall';

export const isNewYearSnowDayTR = (now = new Date()) => {
  const trDate = new Date(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(now)
  );

  trDate.setHours(0, 0, 0, 0);

  const year = trDate.getFullYear();
  const ONE_DAY = 24 * 60 * 60 * 1000;

  const dec31ThisYear = new Date(year, 11, 31);
  dec31ThisYear.setHours(0, 0, 0, 0);

  const dec31PrevYear = new Date(year - 1, 11, 31);
  dec31PrevYear.setHours(0, 0, 0, 0);

  const diffThis = Math.round((trDate.getTime() - dec31ThisYear.getTime()) / ONE_DAY);
  const diffPrev = Math.round((trDate.getTime() - dec31PrevYear.getTime()) / ONE_DAY);

  return (diffThis >= -7 && diffThis <= 7) || (diffPrev >= -7 && diffPrev <= 7);
};

const NewYearSnowOverlay = ({ color }: { color: string }) => (
  <Box
    aria-hidden
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: (t) => t.zIndex.modal + 1000,
      pointerEvents: 'none',
    }}>
    <Snowfall color={color} snowflakeCount={200} radius={[0.8, 3.2]} speed={[0.6, 1.8]} wind={[-0.2, 1.0]} />
  </Box>
);

export default NewYearSnowOverlay;
